"use client";
import React from "react";
import { GameGoaltenders, Sport, TeamBasic } from "common";
import useFetch from "@/utils/fetch";
import Card from "@/components/primitives/card";
import Icon from "@/components/primitives/icon";
import { LoadingCircle } from "@/components/primitives/loading";
import NotFound from "@/components/primitives/not-found";
import TeamDisplay from "@/components/team/display";
import GoaltenderComparisonTable from "./goaltender-comparison-table";

export default function GoaltenderComparison({
  awayTeam,
  homeTeam,
  sport,
  gameId,
  season,
}: {
  awayTeam: TeamBasic;
  homeTeam: TeamBasic;
  sport: Sport;
  gameId: number;
  season: number;
}) {
  const request: string = `${process.env.NEXT_PUBLIC_API_URL}/api/sports/${sport}/goaltender-comparison/${gameId}/${season}`;
  const { data, isLoading, isError, error } = useFetch<GameGoaltenders | null>(null, request, []);
  return (
    <Card
      header={{
        title: (
          <>
          <Icon name="hockey-net" size="md" className="text-primary-500" />
          <span>Goaltender Comparison</span>
          </>
        ),
      }}
    >
      <div className="table-container mt-2">
        {isLoading ? (
          <div className="flex justify-center items-center h-[220px]">
            <LoadingCircle />
          </div>
        ) : !isLoading && (!data || isError) ? (
          <NotFound label="Goaltenders TBD" />
        ) : (
          data && (
            <div className="flex flex-col gap-6">
              <div className="flex flex-col">
                <TeamDisplay
                  sport={sport}
                  variant="abbreviation"
                  size="sm"
                  team={awayTeam}
                />
                <GoaltenderComparisonTable data={data.away} sport={sport} />
              </div>
              <div className="flex flex-col">
                <TeamDisplay
                  sport={sport}
                  variant="abbreviation"
                  size="sm"
                  team={homeTeam}
                />
                <GoaltenderComparisonTable data={data.home} sport={sport} />
              </div>
            </div>
          )
        )}
      </div>
    </Card>
  );
}
